import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react'
import API_ENDPOINTS from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { ConfirmDialog } from 'primereact/confirmdialog';
import Layout from '../common/Layout';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const AffiliateUserOrders = () => {

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [orders, setOrders] = useState([])

    useEffect(() => {
        getOrders()
    }, [])

    const getOrders = () => {
        ApiHelper.get(API_ENDPOINTS.AFFILIATE_USER_ORDERS).then((res) => {
            // console.log('res: ',res);
            if (res.status === 200) {
                setOrders(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.courseImage ? (
                <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }} title={rowData?.courseName}>
                    <div style={{ flexShrink: 0, width: '60px', height: '40px'}} >
                        <img
                            src={`${process.env.REACT_APP_BASE_URL}/${rowData?.courseImage}`}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
                            onError={(e) => {
                                e.target.src = "/img/placeholder-image.jpg"
                            }}
                        />
                    </div>
                    <span className='show-more-text' style={{fontWeight: '600', fontSize: '0.9rem'}}> {rowData?.courseName} </span>
                </div>
            ) : null
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.paymentStatus === 'success' && 'bg-success' || rowData.paymentStatus === 'failed' && 'bg-danger' || rowData.paymentStatus === 'pending' && 'bg-info' }`}>
                {rowData.paymentStatus}
            </span>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

  return (
    <>
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Orders</p></span></h4>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={orders} tableStyle={{ minWidth: '50rem' }} >
                                        <Column body={serialNoTemplate} header='S.NO' />
                                        <Column sortable header='Courses' body={imageBodyTemplate} field='courseName' />
                                        <Column sortable header='Order Number' field='orderNumber' />
                                        <Column sortable header='Total' field='grandTotal' />
                                        <Column sortable header='Status' body={statusBodyTemplate} field='paymentStatus' />
                                        <Column sortable header='Order Date' field='createdAt' body={(rowData) => {
                                            const date = new Date(rowData.createdAt);
                                            return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                        }} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default AffiliateUserOrders
